import Layout from '@/layout/ezpay-index.vue'

export const transitionRouter = {
  path: '/transition',
  component: Layout,
  redirect: '/transition/payin',
  name: 'Transition_Manger',
  meta: { title: 'transaction_manage', icon: 'transactions' },
  children: [
    {
      path: 'transSum',
      name: 'Transaction_Manage_Summary',
      component: () => import('@/views/ezpay/data/transaction-summary.vue'),
      meta: {
        title: 'transaction_summary', noCache: false,
        auth: ['AUTH_CODE_TRANSACTION_STATISTICS']
      }
    },
    {
      path: 'payin',
      name: 'Transaction_Manage_Payin',
      component: () => import('@/views/ezpay/data/payin.vue'),
      meta: {
        title: 'payin', noCache: false,
        auth: ['AUTH_CODE_PAYMENT']
      }
    },
    {
      path: 'refund',
      name: 'Transaction_Manage_Refund',
      component: () => import('@/views/ezpay/data/refund.vue'),
      meta: {
        title: 'refund', noCache: false,
        auth: ['AUTH_CODE_TRANSACTION_REFUND']
      }
    },
    {
      path: 'payout',
      name: 'Transaction_Manage_Payout',
      component: () => import('@/views/ezpay/data/payout.vue'),
      meta: {
        title: 'payout', noCache: false,
        auth: ['AUTH_CODE_PAYOUT']
      }
    }
  ]
}

export const transitionAgentRouter = {
  path: '/transition/agent',
  component: Layout,
  redirect: '/transition/agent/payin',
  name: 'Transition_Manger',
  meta: { title: 'transaction_manage', icon: 'transactions' },
  children: [
    {
      path: 'transSum',
      name: 'Transaction_Manage_Agent_Summary',
      component: () => import('@/views/ezpay/data-agent/transaction-summary.vue'),
      meta: {
        title: 'transaction_summary', noCache: false,
        auth: ['ROLE_AUTH_AGENT_ADMIN']
      }
    },
    {
      path: 'payin',
      name: 'Transaction_Manage_Agent_Payin',
      component: () => import('@/views/ezpay/data-agent/payin.vue'),
      meta: {
        title: 'payin', noCache: false,
        auth: ['ROLE_AUTH_AGENT_ADMIN']
      }
    },
    {
      path: 'refund',
      name: 'Transaction_Manage_Refund',
      component: () => import('@/views/ezpay/data-agent/refund.vue'),
      meta: {
        title: 'refund', noCache: false,
        auth: ['ROLE_AUTH_AGENT_ADMIN']
      }
    },
    {
      path: 'payout',
      name: 'Transaction_Manage_Agent_Payout',
      component: () => import('@/views/ezpay/data-agent/payout.vue'),
      meta: {
        title: 'payout', noCache: false,
        auth: ['ROLE_AUTH_AGENT_ADMIN']
      }
    }
  ]
}
